var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-image',{attrs:{"src":_vm.dropFileURL,"ratio":"64by64","alt":"Profilbild","rounded":""}}),_c('button',{staticClass:"delete is-small mt-3",attrs:{"type":"button"},on:{"click":_vm.deleteDropFile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }